export class StatisticheProdotti {
  uidPietanza: string;
  quantita: number;
}
